import React from "react";
import { Home as HomeIcon, Car, Search, MessageCircle, Sparkles } from "lucide-react";
import { Checkbox } from "./ui/checkbox";
import AdminBadge from "./AdminBadge";

const WHATSAPP = "5541984584456";

export function buildWhatsAppLink(cota) {
  const msg = `Olá! Tenho interesse na carta contemplada:%0A%0A*Código:* ${cota.codigo}%0A*Administradora:* ${cota.administradora}%0A*Crédito:* ${cota.credito_fmt}%0A*Entrada:* ${cota.entrada_fmt}%0A*Parcelas:* ${cota.parcelas} x ${cota.vlr_parcela}`;
  return `https://wa.me/${WHATSAPP}?text=${msg}`;
}

export default function CotaCard({ cota, selected, onToggle, onDetails, destaque }) {
  const Icon = cota.segmento === "veiculo" ? Car : HomeIcon;
  return (
    <div className={`card-hover relative bg-white border rounded-2xl p-4 md:p-5 fade-in ${destaque ? "border-[#C9A227] shadow-[0_0_0_1px_#C9A227]" : "border-slate-200"}`}>
      {destaque && (
        <div className="absolute -top-3 left-5 z-10 inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-white text-[11px] font-extrabold uppercase tracking-wide shadow-md"
          style={{ background: "linear-gradient(135deg,#e7c869,#C9A227)" }}>
          <Sparkles size={13} /> Oportunidade
        </div>
      )}
      <div className="flex flex-col lg:flex-row lg:items-center gap-4">
        {/* icon + credito */}
        <div className="flex items-center gap-4 lg:w-[28%] min-w-[220px]">
          <div className="h-14 w-14 shrink-0 rounded-xl bg-[#faf1d6] flex items-center justify-center">
            <Icon className="text-[#C9A227]" size={26} strokeWidth={1.8} />
          </div>
          <div>
            <div className="text-[13px] font-semibold text-slate-400">{cota.administradora}</div>
            <div className="text-xl md:text-2xl font-extrabold text-slate-600 leading-tight">
              {cota.credito_fmt}
            </div>
          </div>
        </div>

        {/* entrada */}
        <div className="lg:w-[20%]">
          <div className="text-[12px] text-slate-400">Entrada :</div>
          <div className="text-[15px] font-bold text-slate-600">{cota.entrada_fmt}</div>
        </div>

        {/* parcelas */}
        <div className="lg:w-[22%]">
          <div className="text-[12px] text-slate-400">Parcelas:</div>
          <div className="text-[15px] font-bold text-slate-600">
            {cota.parcelas} <span className="text-slate-400 font-normal">x</span> {cota.vlr_parcela}
          </div>
        </div>

        {/* codigo */}
        <div className="lg:w-[15%]">
          <div className="text-[12px] text-slate-400">Código:</div>
          <div className="text-[15px] font-bold text-slate-600">{cota.codigo}</div>
        </div>

        {/* badge */}
        <div className="lg:w-[15%] flex lg:justify-end">
          <AdminBadge name={cota.administradora} />
        </div>
      </div>

      <div className="mt-4 pt-4 border-t border-slate-100 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
        <label className="flex items-center gap-2 cursor-pointer select-none sm:mr-auto">
          <Checkbox checked={selected} onCheckedChange={() => onToggle(cota.codigo)} />
          <span className="text-xs font-semibold text-slate-500">Selecionar</span>
        </label>

        <button
          onClick={() => onDetails(cota)}
          className="flex-1 sm:flex-none inline-flex items-center justify-center gap-2 px-6 py-2.5 rounded-lg bg-slate-100 hover:bg-slate-200 text-slate-600 text-sm font-semibold transition-colors"
        >
          <Search size={16} /> Detalhes
        </button>

        <a
          href={buildWhatsAppLink(cota)}
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 sm:flex-none inline-flex items-center justify-center gap-2 px-6 py-2.5 rounded-lg bg-[#25a55b] hover:bg-[#1f9350] text-white text-sm font-semibold transition-colors shadow-sm"
        >
          <MessageCircle size={16} /> Negociar
        </a>
      </div>
    </div>
  );
}
